import React from 'react';
import {Card, CardBody, CardText} from "reactstrap";

const renderExplanation = (explanation) => {
    return <Card className="Task" outline color="info">
        <CardBody>
            <CardText dangerouslySetInnerHTML={{ __html: explanation }}/>
        </CardBody>
    </Card>
}

export default renderExplanation;
